import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import store from '@/store/index'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/addresses',
        name: 'Addresses',
        component: () => import(/* webpackChunkName: "addresses" */ '../views/Addresses.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/faqs',
        name: 'Faqs',
        component: () => import(/* webpackChunkName: "faqs" */ '../views/Faqs.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/inspections',
        name: 'Inspections',
        component: () => import(/* webpackChunkName: "inspections" */ '../views/Inspections.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/tank',
        name: 'Tank',
        component: () => import(/* webpackChunkName: "tank" */ '../views/Tank.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/tire',
        name: 'Tire',
        component: () => import(/* webpackChunkName: "tire" */ '../views/Tire.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/oil',
        name: 'Oil',
        component: () => import(/* webpackChunkName: "oil" */ '../views/Oil.vue'),
        meta: {
            requiresAuth: true,
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    routes,
})

router.beforeEach((to, from, next) => {
    const isLoggedIn = store.getters.isLoggedIn

    if (!isLoggedIn && to.name !== 'Login') {
        next({ name: 'Login' })
    } else if (isLoggedIn && to?.name === 'Login') {
        next({ name: 'Home' })
    } else {
        next()
    }
})

export default router
